/**
 * Single source of truth for every localStorage/sessionStorage key used in
 * the app.
 */
export const LOCAL_STORAGE_KEYS = {
  BASKET: 'basket',
  LEAD: 'lead',
  // Persists the incentive timer's expiry so a page refresh doesn't reset the
  // countdown. Claimed by the ZOE Plus entry in lib/checkout/incentiveTimers.ts;
  // see lib/checkout/resolveIncentiveTimerExpiry.ts for the 28-day cool-off.
  ZOE_PLUS_INCENTIVE_TIMER_EXPIRES_AT: 'zoePlusIncentiveTimerExpiresAt',
} as const

export const SESSION_STORAGE_KEYS = {
  // Remembers which paywall (e.g. plans vs plans-reactivate) a user entered the
  // checkout funnel from, so the checkout back button can return them to it.
  ZOE_PLUS_CHECKOUT_ORIGIN: 'zoePlusCheckoutOrigin',
  LOCALE_BANNER_DISMISSED: 'cLocaleMismatchBannerDismissed',
  D30_SELECTED_PRODUCT: 'd30SelectedProduct',
  D30_QUIZ_COMPLETE: 'zoe_d30_quiz_complete',
  // Persists forced Optimizely flag overrides (?opt_<FLAG>=variation-N) so they
  // survive client-side navigation to the page under test. See context/optimizelyContext.tsx.
  OPTIMIZELY_OVERRIDES: 'optimizelyFlagOverrides',
} as const
